import { render, staticRenderFns } from "./ScanTen.vue?vue&type=template&id=0b12cdc7&scoped=true"
import script from "./ScanTen.vue?vue&type=script&lang=js"
export * from "./ScanTen.vue?vue&type=script&lang=js"
import style0 from "./ScanTen.vue?vue&type=style&index=0&id=0b12cdc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b12cdc7",
  null
  
)

export default component.exports